// import hooks
import { useState, useCallback } from "react";
import useEventListener from "../../hooks/useEventListener/index.js";
import templateStore from "../../client-store/template.store.js";
export const useTabFocus = () => {
    const [isFocussed, setIsFocussed] = useState(true);
    const _focusHandler = useCallback(() => {
        setIsFocussed(true);
        templateStore.setFocus(true);
    }, []);
    const _blurHandler = useCallback(() => {
        setIsFocussed(false);
        templateStore.setFocus(false);
    }, []);
    useEventListener({
        eventName: "focus",
        payload: _focusHandler,
    });
    useEventListener({
        eventName: "blur",
        payload: _blurHandler,
    });
    return isFocussed;
};
export default useTabFocus;
